import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getListNotificationAPI } from '../../../api/notify';

// First, create the thunk
export const fetchNotification = createAsyncThunk(
  'notification/fetchNotification',
  async ({ query }: { query: string }, { dispatch, rejectWithValue }) => {
    try {
      const response = await getListNotificationAPI(query);
      return response.data;
    } catch (error) {}
  },
);

const initialState: any = {
  isFetching: true,
  pagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  },
  result: [],
};

export const notification = createSlice({
  name: 'notification',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchNotification.pending, (state) => {
      state.isFetching = true;
    });

    builder.addCase(fetchNotification.rejected, (state) => {
      state.isFetching = false;
    });

    builder.addCase(fetchNotification.fulfilled, (state, action) => {
      state.isFetching = false;
      state.pagination = action.payload?.pagination;
      state.result = action.payload?.data;
    });
  },
});
export default notification.reducer;
